import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, FileText, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { products } from '../mock/mockData';

const PoleCard = ({ product }) => {
  const navigate = useNavigate();

  const handleRequestQuote = () => {
    navigate('/installation');
  };

  return (
    <Card className="hover:shadow-2xl transition-all duration-300 group">
      <div className="relative overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {product.bestseller && (
          <Badge className="absolute top-4 right-4 bg-red-600 text-white">
            Bestseller
          </Badge>
        )}
        {product.inStock ? (
          <Badge className="absolute top-4 left-4 bg-green-600 text-white">
            Available
          </Badge>
        ) : (
          <Badge className="absolute top-4 left-4 bg-slate-400 text-white">
            Contact for Availability
          </Badge>
        )}
        {product.series && (
          <Badge className="absolute bottom-4 left-4 bg-slate-900 text-white">
            {product.series}
          </Badge>
        )}
      </div>
      <CardContent className="p-6">
        <h3 className="font-bold text-xl mb-2 text-slate-900">{product.name}</h3>
        <p className="text-slate-600 text-sm mb-4 min-h-[40px]">{product.description}</p>
        
        {/* Features */}
        <div className="mb-4 space-y-1">
          {product.features.slice(0, 3).map((feature, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm text-slate-600">
              <Check className="w-4 h-4 text-green-600" />
              <span>{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 pt-4 border-t">
          <div className="text-center">
            <span className="text-lg font-semibold text-slate-700">Call for Pricing</span>
            <p className="text-sm text-slate-500">Custom quotes based on your needs</p>
          </div>
          <Button
            onClick={handleRequestQuote}
            className="w-full bg-blue-600 hover:bg-blue-700"
            data-testid={`quote-btn-${product.id}`}
          >
            <FileText className="w-4 h-4 mr-2" /> Request Quote
          </Button>
          <a 
            href="tel:205-587-2402" 
            className="flex items-center justify-center gap-2 text-slate-600 hover:text-blue-600 transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm font-medium">205-587-2402</span>
          </a>
        </div>
      </CardContent>
    </Card>
  );
};

const Poles = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-white py-12 border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold text-slate-900 mb-4">Flagpoles & Hardware</h1>
            <p className="text-xl text-slate-600">
              Complete flagpole kits with all hardware included. Professional installation services available throughout the Gulf Coast.
            </p>
            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-blue-800 font-medium">
                📞 Call us at <a href="tel:205-587-2402" className="underline">205-587-2402</a> or request a quote below for personalized pricing based on your location and installation needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.poles.map((product) => (
              <PoleCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Poles;
